import React from 'react';
import { GROUPED_ORDER } from '../../Pages';

export default {
  path: GROUPED_ORDER.pageURL,
  async action() {
    const { default: AdminGroupedOrderList } =
      await import('./AdminGroupedOrderList');
    return <AdminGroupedOrderList key={'groupedorders'} />;
  },
};
